var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlechaRightUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0044 3.74041C21.0044 3.74041 21.0044 3.74041 21.0044 3.73041C21.0044 3.64036 20.9844 3.56031 20.9544 3.48027C20.9444 3.45025 20.9344 3.43024 20.9144 3.40022C20.8844 3.34019 20.8544 3.29016 20.8144 3.25014C20.7944 3.23013 20.7844 3.21012 20.7644 3.19011C20.7044 3.14008 20.6444 3.09005 20.5644 3.06003C20.5644 3.06003 20.5544 3.06003 20.5444 3.05003C20.4644 3.02001 20.3744 3 20.2844 3C20.2844 3 20.2644 3 20.2544 3L3.75439 3.02001C3.34439 3.02001 3.00439 3.3602 3.00439 3.77043C3.00439 4.18066 3.34439 4.52085 3.75439 4.52085L18.4444 4.50083L3.24439 19.7193C2.95439 20.0094 2.95439 20.4897 3.24439 20.7799C3.53439 21.07 4.01439 21.07 4.30439 20.7799L19.5044 5.55142V20.2496C19.5044 20.6598 19.8444 21 20.2544 21C20.6644 21 21.0044 20.6598 21.0044 20.2496V3.74041Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaRightUp);
export default __webpack_public_path__ + "static/media/flecha_right_up.e590cd34.svg";
export { ForwardRef as ReactComponent };